module.exports = __webpack_public_path__ + "startpage-746fed5a/template-7-preview-d132bb2d8dc18513da52a98cbe052aa0.jpg";